﻿export enum OperationType {
  Insert = 0,
  Update = 1,
  Delete = 2,
  None = 3,
}

export type OperationTypeV4 = 'Insert' | 'Update' | 'Delete' | 'None';
